import { useContext } from 'react';
import { ScreenTypeContext } from '../../providers/ScreenTypeProvider';

export default function useScreenType() {
  return useContext(ScreenTypeContext);
}
